import type { FaireProductEntity } from "../../entity_types/product";

export const p_xcpc7zfsh4: FaireProductEntity = {
  token: "p_xcpc7zfsh4",
  type: "product",
  name: "Scalloped Poppy thank you greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/eccdf55000df8990d932eabaf513bc04bbffb124ba6cc80f04a24400261bb10a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d47888c26be272406949586fd72d62d1b1d646dc504887e680d67d750feaa54.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Die cut, offset printed and foil stamped. 4.25 x 5.5 inches. Illustrated by the House that Lars Built. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:21.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
